import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 90%;
  margin: 5% 10% 10% 10%;
  display: flex;
  justify-content: space-between;
`;

const PresentationsWrapper = styled.div`
  width: 70%;
`;

const PresentationsHeader = styled.h1`
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
`;

const PresentationsType = styled.div`
  position: relative;
`;

const PresentationsTypeHeader = styled.h2`
  padding-bottom: 10px;
`;

const PresentationsSubtypeHeader = styled.h3`
  padding-bottom: 10px;
`;

const Presentation = styled.div`
  font-size: 12pt;
  padding-bottom: 20px;
  padding-left: 60px;
  &:before {
    /* content: "2024"; */
    content: ${(props) => (props.year ? `"${props.year}"` : `""`)};
    position: absolute;
    left: 0px;
    // font-weight: bold;
    display: inline-block;
    color: black;
  }
`;

const PresentationCitation = styled.div`
  padding-left: 36px;
  text-indent: -36px;
`;

const UnderlineAuthor = styled.span`
  font-weight: bold;
  text-decoration: underline;
`;

const PrimaryPublication = styled.span`
  font-style: italic;
`;

const PresentationTags = styled.div`
  margin: 0px 36px;
  font-size: 9pt;
  display: flex;
  flex-wrap: wrap;
`;

const PresentationTag = styled.div`
  background-color: slategray;
  color: white;
  border-radius: 20px;
  margin: 5px 5px;
  padding: 5px 10px;
  font-weight: bold;
  white-space: nowrap;
`;

const PresentationsTypeBreak = styled.hr`
  margin: 0px 0px 20px 0px;
  color: lightgray;
`;

const Link = styled.a`
  color: blue;
  text-decroation: underline;
`;

const Presentations = () => {
  return (
    <Container>
      <PresentationsWrapper>
        <PresentationsHeader>Presentations</PresentationsHeader>
        <PresentationsType>
          <PresentationsTypeHeader>Refereed</PresentationsTypeHeader>
          <PresentationsSubtypeHeader>Linguistics</PresentationsSubtypeHeader>
          <Presentation year={"2025"}>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025.
              Historical linguistics data citation and reusability: With a case
              study of the Sumatran comparative database. Paper presented at the{" "}
              <PrimaryPublication>
                27ᵗʰ International Conference on Historical Linguistics (ICHL27)
              </PrimaryPublication>
              , Santiago, Chile, 18–22 August. (
              <Link
                href={
                  "./files/presentations/Billings_2025_HistoricalLinguisticsDataCitationAndReusability.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
          </Presentation>
          <Presentation>
            <PresentationCitation>
              Bradley McDonnell &{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025.
              Variation and change in Nasal function words. Paper presented at
              the{" "}
              <PrimaryPublication>
                17ᵗʰ Conference on Austronesian and Papuan Languages and
                Linguistics (APLL17)
              </PrimaryPublication>
              , Cologne, Germany, 21–23 July.
            </PresentationCitation>
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025. DATAR:
              Making level ground for future linguistic work to stand on. Paper
              presented at the{" "}
              <PrimaryPublication>
                AIFIS-MSU Conference on Indonesian Studies
              </PrimaryPublication>
              , Remote, 17–21 June. (
              <Link
                href={
                  "./files/presentations/Billings_2025_DATARMakingLevelGroundForFutureLinguisticWorkToStandOn.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
          </Presentation>{" "}
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025.
              Embedding dictionary development in the documentary workflow.
              Poster presented at the{" "}
              <PrimaryPublication>
                NINJAL 2025 Language Revitalization Synergy Symposium (LRSS)
              </PrimaryPublication>
              , Tokyo, Japan, 13–16 June. (
              <Link
                href={
                  "./files/presentations/Billings_2025_EmbeddingDictionaryDevelopmentInTheDocumentaryWorkflow.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025. The
              state of Sumatran lexicography: Ongoing projects and prospects for
              lexical documentation. Paper presented at the{" "}
              <PrimaryPublication>
                25ᵗʰ Biennial Dictionary Society of North America Conference
                (DSNA25)
              </PrimaryPublication>
              , Buffalo, NY, USA, 29–31 May. (
              <Link
                href={
                  "./files/presentations/Billings_2025_TheStateOfSumatranLexicographyOngoingProjectsAndProspectsForLexicalDocumentation.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025.
              Metalexicography for the documentary linguist: Informing internal
              documentation with external materials. Paper presented at the{" "}
              <PrimaryPublication>
                Southeastern Conference on Linguistics 2025 (SECOL2025)
              </PrimaryPublication>
              , Boca Raton, FL, USA, 10–12 April. (
              <Link
                href={
                  "./files/presentations/Billings_2025_MetalexicographyForTheDocumentaryLinguistInformingInternalDocumentationWithExternalMaterials.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025.
              Documentary lexicography: The need for a field. Paper presented at
              the{" "}
              <PrimaryPublication>
                9ᵗʰ International Conference on Language Documentation and
                Conservation (ICLDC9)
              </PrimaryPublication>
              , Honolulu, HI, 6–9 March. (
              <Link
                href={
                  "./files/presentations/Billings_2025_DocumentaryLexicography.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Jacob Hakim,
              Johan Safri, Wawan Sahrozi, Bradley McDonnell, & Yanti. 2025.
              Collaborative documentation as a catalyst for language
              maintenance. Paper presented at the{" "}
              <PrimaryPublication>
                9ᵗʰ International Conference on Language Documentation and
                Conservation (ICLDC9)
              </PrimaryPublication>
              , Honolulu, HI, 6–9 March. (
              <Link
                href={
                  "./files/presentations/BillingsEtAl_2025_CollaborativeDocumentationAsACatalystForLanguageMaintenance.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Bradley
              McDonnell, Johan Safri, & Wawan Sahrozi. 2025. Connecting
              automated speech recognition to transcription practices. Paper
              presented at the{" "}
              <PrimaryPublication>
                8ᵗʰ Workshop on the Use of Computational Methods in the Study of
                Endangered Languages (ComputEL-8)
              </PrimaryPublication>
              , Honolulu, HI, 4–5 March. (
              <Link
                href={
                  "./files/presentations/BillingsMcDonnell_2025_ConnectingAutomatedSpeechRecognitionToTranscriptionPractices.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
          </Presentation>
          <Presentation year={"2024"}>
            <PresentationCitation>
              Shelece Easterday,{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, & Clemens
              Mayer. 2024. Emergence of divergent phonotactics in Austronesian:
              A distributional typological approach. Panel paper presented at
              the{" "}
              <PrimaryPublication>
                16ᵗʰ International Conference on Austronesian Linguistics
                (ICAL16)
              </PrimaryPublication>
              , Manila, Philippines, 20–24 June. (
              <Link
                href={
                  "./files/presentations/EasterdayEtAl_2024_EmergenceOfDivergentPhonotacticsInAustronesianADistributedTypologicalApproach.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Phonological Typology</PresentationTag>
              <PresentationTag>Austronesian</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation>
            <PresentationCitation>
              Bradley McDonnel,{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Jacob Hakim,
              Dendi Wijaya, & Yanti. 2024. A window into the early history of
              langauge contact in Sumatra. Paper presented at the{" "}
              <PrimaryPublication>
                16ᵗʰ International Conference on Austronesian Linguistics
                (ICAL16)
              </PrimaryPublication>
              , Manila, Philippines, 20–24 June. (
              <Link
                href={
                  "./files/presentations/McDonnellEtAl_2024_AWindowIntoTheEarlyHistoryOfLanguageContactInSumatra.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Language Contact</PresentationTag>
              <PresentationTag>Austronesian (Sumatra)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2024. Do you
              *c what I *c? Proto-Batak palatals and what they (don't) say about
              PMP. Paper presented at the{" "}
              <PrimaryPublication>
                33ʳᵈ Conference of the Southeast Asian Linguistics Society
                (SEALS33)
              </PrimaryPublication>
              , Taipei, Taiwan, 15–17 June. (
              <Link
                href={
                  "./files/presentations/Billings_2024_ProtoBatakPalatalsDoYouCWhatIC.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Historical Linguistics</PresentationTag>
              <PresentationTag>Austronesian (Sumatra)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2024. Building
              a comparative lexical database for the Sumatran languages. Paper
              presented at the{" "}
              <PrimaryPublication>
                31ˢᵗ Annual Meeting of the Austronesian Formal Linguistics
                Association (AFLA31)
              </PrimaryPublication>
              , Amherst, MA, USA, 12–14 June. (
              <Link
                href={
                  "./files/presentations/Billings_2024_BuildingAComparativeLexicalDatabaseForTheSumatranLanguages.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Historical Linguistics</PresentationTag>
              <PresentationTag>Austronesian (Sumatra)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation year={"2023"}>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2023.
              Contact-induced phonological change in the Sumatran languages.
              Poster presented at the{" "}
              <PrimaryPublication>
                Sixth Edinburgh Symposium on Historical Phonology (ESHP6)
              </PrimaryPublication>
              , Edinburgh, Scotland, UK, 4–5 December. (
              <Link
                href={
                  "./files/presentations/Billings_2023_ContactInducedPhonologicalChangeInTheSumatranLanguages.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Language Contact</PresentationTag>
              <PresentationTag>Austronesian (Sumatra)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor> & Bradley
              McDonnell. 2023. On the use of Malay function words in Nasal.
              Paper presented at the{" "}
              <PrimaryPublication>
                26ᵗʰ International Symposium on Malay and Indonesian Linguistics
                (ISMIL26)
              </PrimaryPublication>
              , Honolulu, HI, USA, 18–20 May. (
              <Link
                href={
                  "./files/presentations/BillingsMcDonnell_2023_OnTheUseOfMalayFunctionWordsInNasal.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Language Contact</PresentationTag>
              <PresentationTag>Austronesian (Sumatra)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation>
            <PresentationCitation>
              Nay San, Martijn Bartelds,{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Ella del
              Falco, Johan Safri, Wawan Sahrozi, Ben Foley, Bradley McDonnell, &
              Dan Jurafsky. 2023. Leveraging supplementary text data to
              kick-start automatic speech recognition system development with
              limited transcriptions. Paper presented at the{" "}
              <PrimaryPublication>
                6ᵗʰ Workshop on Computational Methods for Endangered Languages
                (ComputEL-6)
              </PrimaryPublication>
              , Honolulu, HI, USA, 5–6 March.
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Computational Linguistics</PresentationTag>
              <PresentationTag>Automated Speech Transcription</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation>
            <PresentationCitation>
              Laura Griffin & <UnderlineAuthor>Blaine Billings</UnderlineAuthor>
              . 2023. A sketch of modals in Chuukic languages. Paper presented
              at the{" "}
              <PrimaryPublication>
                22ⁿᵈ East-West Center International Graduate Student Conference
              </PrimaryPublication>
              , Honolulu, HI, USA, 16–18 February. (
              <Link
                href={
                  "./files/presentations/GriffinBillings_2023_ASketchOfModalsInChuukicLanguages.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Modality</PresentationTag>
              <PresentationTag>Austronesian (Micronesia)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation year={"2022"}>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Jacob Hakim,
              Bradley McDonnell, Yanti, Johan Safri, Wawan Sahrozi, & Hendi
              Feriza. 2022. Constructing a multilingual corpus of everyday
              conversations. Paper presented at the{" "}
              <PrimaryPublication>
                14ᵗʰ Conference of the Association for Linguistic Typology
                (ALT14)
              </PrimaryPublication>
              , Austin, TX, USA, 15–17 December. (
              <Link
                href={
                  "./files/presentations/BillingsEtAl_2022_ConstructingAMultilingualCorpusOfEverydayConversations.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Corpus Development</PresentationTag>
              <PresentationTag>Multilingualism</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor> & Bradley
              McDonnell. 2022. Subgrouping Malayo-Polynesian languages of
              Sumatra and the Barrier Islands. Paper presented at the{" "}
              <PrimaryPublication>
                31ˢᵗ Conference of the Southeast Asian Linguistics Society
                (SEALS33)
              </PrimaryPublication>
              , Honolulu, HI, USA, 18–20 May. (
              <Link
                href={
                  "./files/presentations/BillingsMcDonnell_2022_SubgroupingMalayoPolynesianLanguagesOfSumatraAndTheBarrierIslands.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Historical Linguistics</PresentationTag>
              <PresentationTag>Austronesian (Sumatra)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <PresentationsSubtypeHeader>
            Mathematics / Computer science
          </PresentationsSubtypeHeader>
          <Presentation year={2019}>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Terence Carey,
              Xandre Clementsmith, & Lancie Affonso. 2019. Integrating STEAM
              education in classroom living learning communities. Poster
              presented at{" "}
              <PrimaryPublication>
                College of Charleston School of Sciences and Mathematics 31ˢᵗ
                Annual Poster Session
              </PrimaryPublication>
              , Charleston, SC, USA, 28 April.
            </PresentationCitation>
          </Presentation>
          <Presentation year={2018}>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor> & Xenia
              Mountrouidou. 2018. Modeling correct operation of webcams for
              security purposes. Paper and poster presented at{" "}
              <PrimaryPublication>
                Special Interest Group for Computer Science Education 2018
                (SIGCSE2018) Undergraduate Student Research Competition
              </PrimaryPublication>
              , Baltimore, MD, USA, 21–24 February.
            </PresentationCitation>
          </Presentation>
          <Presentation year={2017}>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor> & Dinesh
              Sarvate. 2017. GDD(<i>n</i>,2,4;λ₁,λ₂) with equal number of blocks
              of three configurations. Paper presented at{" "}
              <PrimaryPublication>
                31ˢᵗ Midwestern Conference on Combinatorics and Combinatorial
                Computing (MCCCC)
              </PrimaryPublication>
              , Carrollton, GA, USA, 20–22 October.
            </PresentationCitation>
          </Presentation>
          <Presentation>
            <PresentationCitation>
              Xenia Mountrouidou,{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, & Luis
              Mejía-Ricart. 2017. An internet of things taxonomy: Characterizing
              and classifying modern devices. Poster presented at{" "}
              <PrimaryPublication>
                College of Charleston School of Sciences and Mathematics 29ᵗʰ
                Annual Poster Session
              </PrimaryPublication>
              , Charleston, SC, USA, 20 April.
            </PresentationCitation>
          </Presentation>{" "}
          <Presentation year={2015}>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>, Kasifa
              Namyalo, & Dinesh G. Sarvate. 2015. GDD(<i>n</i>₁+<i>n</i>
              ₂,3;λ₁,λ₂) with equal number of blocks of two configurations.
              Paper presented at{" "}
              <PrimaryPublication>
                29th Midwestern Conference on Combinatorics and Combinatorial
                Computing (MCCCC)
              </PrimaryPublication>
              , Charleston, SC, USA, 17–19 October.
            </PresentationCitation>
          </Presentation>
        </PresentationsType>
        <PresentationsTypeBreak />
        <PresentationsType>
          <PresentationsTypeHeader>Invited talks</PresentationsTypeHeader>
          <PresentationsSubtypeHeader>Linguistics</PresentationsSubtypeHeader>
          <Presentation year={"2025"}>
            <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025.
            Documentary lexicography and reflections on documenting the Nasal
            lexicon. Invited talk at{" "}
            <PrimaryPublication>Friday Colloquium Series</PrimaryPublication>,
            University of North Carolina at Chapel Hill, Chapel Hill, NC, 7
            November. (
            <Link
              href={
                "./files/presentations/Billings_2025_DocumentaryLexicographyAndReflectionsOnDocumentingTheNasalLexicon.pdf"
              }
              target="_blank"
            >
              PDF
            </Link>
            )
          </Presentation>
          <Presentation>
            <PresentationCitation>
              Bradley McDonnell &{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2025.
              Divergence and convergence in Sumatra and the Barrier Islands.
              Presented at{" "}
              <PrimaryPublication>
                The Enggano language documentation and lexicography: A
                reflection
              </PrimaryPublication>
              , Udayana University, Denpasar, Indonesia, 9 January. (
              <Link
                href={
                  "./files/presentations/McDonnellBillings_2025_DivergenceAndConvergenceInSumatraAndTheBarrierIslands.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
          </Presentation>
          <Presentation year={"2023"}>
            <PresentationCitation>
              Bradley McDonnell, Yanti, Dendi Wijaya, Jacob Hakim, &{" "}
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2023. The
              changing face of language documentation: Examples from Indonesia.
              Presented at the{" "}
              <PrimaryPublication>
                Center for Southeast Asian Studies
              </PrimaryPublication>
              , University of Hawai'i at Mānoa, Honolulu, HI, USA, 8 November. (
              <Link
                href={
                  "./files/McDonnellEtAl_2023_TheChangingFaceOfLanguageDocumentationExamplesFromIndonesia.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Language Contact</PresentationTag>
              <PresentationTag>Austronesian (Sumatra)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation year={"2021"}>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2021.
              Historical Phonology of the Languages of Northwest Sumatra and the
              Barrier Islands. Presented at the{" "}
              <PrimaryPublication>Austronesian Circle</PrimaryPublication> ,
              University of Hawai'i at Mānoa, Honolulu, HI, USA, 26 October.
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Historical Linguistics</PresentationTag>
              <PresentationTag>Austronesian (Sumatra)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2021.
              Reconsidering modal stacking in a generative framework. Invited
              talk at
              <PrimaryPublication>
                LING 320: Fundamentals of generative syntax
              </PrimaryPublication>
              , College of Charleston, Charleston, SC, USA, 13 April.
            </PresentationCitation>
          </Presentation>
          <Presentation>
            <PresentationCitation>
              <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2021. The
              languages of Alor regency: Assessing language endangerment.
              Presentation at the{" "}
              <PrimaryPublication>
                Webinar Bahasa-Bahasa yang Hampir Punah 3
              </PrimaryPublication>{" "}
              [3ʳᵈ Webinar on Endangered Languages], Kupang, Nusa Tenggara
              Timor, Indonesia, 30 March. (
              <Link
                href={
                  "./files/Billings_2021_TheLanguagesOfAlorRegencyAssessingLanguageEndangerment.pdf"
                }
                target="_blank"
              >
                PDF
              </Link>
              )
            </PresentationCitation>
            {/* <PresentationTags>
              <PresentationTag>Language Endangerment</PresentationTag>
              <PresentationTag>Austronesian (Alor)</PresentationTag>
            </PresentationTags> */}
          </Presentation>
        </PresentationsType>
        <PresentationsTypeBreak />
        <PresentationsType>
          <PresentationsTypeHeader>Other</PresentationsTypeHeader>
          <PresentationsSubtypeHeader>Linguistics</PresentationsSubtypeHeader>
          <Presentation year={"2026"}>
            <UnderlineAuthor>Blaine Billings</UnderlineAuthor>. 2026.
            <PrimaryPublication>
              Documentary lexicography: A case study of building the Nasal
              dictionary
            </PrimaryPublication>
            . Dissertation defense, University of Hawai‘i at Mānoa, Honolulu,
            HI, 6 May. (
            <Link
              href={
                "./files/presentations/Billings_2026_DissertationDefense.pdf"
              }
              target="_blank"
            >
              PDF
            </Link>
            )
          </Presentation>
        </PresentationsType>
      </PresentationsWrapper>
    </Container>
  );
};

export default Presentations;
